import { useContext } from "react";
import { RTLContext } from "../context/RTLContext";

const useRTLContext = () => useContext(RTLContext);
export default useRTLContext;
